<template>
<div>
    <navbar id="nav">
  </navbar>
  <h3>Welcome!</h3>
  <!-- <div class="m-5">This study has finished recruitment. Thanks for your interests!</div> -->
  <div class="m-5">
     <alert :message="message" v-if="showMessage"></alert>
     <b-alert :show="notQualify" variant="danger" style="width:50%" class="mx-auto">
<h5>You do not qualify for this HIT! </h5>
  <p>According to your MTurk ID, you have already done this hit or one that is very similar.
     Do not accept this HIT, if you do - you will not be paid.<br>
     If you already signup and click <router-link to="/login">here</router-link> to login.</p>
     </b-alert>
    <b-form @submit="onSubmit" v-if="show">
      <b-form-group>
        <b-row align-h="center" class="text-left">
          <b-col sm="2">
            <label for="input-workerID">MTurk Worker ID</label>
          </b-col>
          <b-col sm="4">
            <b-form-input
              id="input-workerID"
              v-model="form.workerID"
              required
              placeholder="Please Enter your worker ID"
            ></b-form-input>
          </b-col>
        </b-row>
      </b-form-group>
      <vue-recaptcha
        ref="recaptcha"
        @verify="onCaptchaVerified"
        @expired="onCaptchaExpired"
        size="invisible"
        sitekey="6LevCiUaAAAAALtTF7eluOKHpqN98E7uu7O0S3-3"
        :loadRecaptchaScript="true">
      </vue-recaptcha>
      <b-button type="submit" class="rounded-pill m-4" variant="info" :disabled='isDisabled'>
        {{btnText}}
      </b-button>
    </b-form>
  </div>
</div>
</template>

<script>
import VueRecaptcha from 'vue-recaptcha';
import axios from 'axios';
import Alert from '../Other/Alert.vue';
import Nav from '../Other/Nav.vue';

export default {
  name: 'Signup',
  data() {
    return {
      form: {
        workerID: '',
      },
      show: true,
      showMessage: false,
      isDisabled: false,
      notQualify: false,
      btnText: 'Sign Up',
    };
  },
  components: {
    alert: Alert,
    navbar: Nav,
    VueRecaptcha,
  },
  methods: {
    // signup(payload) {
    //   const path = `${this.$hostname}/submit-signup`;
    //   // const path = 'http://localhost:8080/submit-signup';
    //   axios
    //     .post(path, payload)
    //     .then((res) => {
    //       if (res.data.status === 'success') {
    //         localStorage.clear();
    //         localStorage.userID = res.data.userID;
    //         localStorage.taskID = res.data.taskID;
    //         localStorage.workerID = res.data.workerID;
    //         localStorage.first_name = 'Friend!';
    //         localStorage.accountProgress = res.data.accountProgress;
    //         this.$router.push({ name: 'Demographic' });
    //         this.message = 'Success';
    //         this.showMessage = true;
    //         this.isDisabled = false;
    //       } else if (res.data.status === 'existed') {
    //         this.notQualify = true;
    //       }
    //     })
    //     .catch((error) => {
    //       // eslint-disable-next-line
    //       console.log(error);
    //       this.message = 'Sign Up Error, please contact lrntnkdo@pitt.edu';
    //       this.showMessage = true;
    //       this.isDisabled = false;
    //     });
    // },
    initForm() {
      this.workerID = '';
    },
    onSubmit(evt) {
      evt.preventDefault();
      this.isDisabled = true;
      console.log('Before recaptcha');
      this.$refs.recaptcha.execute();
    },
    onCaptchaVerified(recaptchaToken) {
      console.log('Starting recaptcha');
      this.btnText = 'submitting';
      this.$refs.recaptcha.reset();
      const path = `${this.$hostname}/submit-signup`;
      axios.post(path, {
        workerID: this.form.workerID,
        recaptchaToken,
      }).then((res) => {
        if (res.data.status === 'success') {
          localStorage.clear();
          localStorage.userID = res.data.userID;
          localStorage.taskID = res.data.taskID;
          localStorage.workerID = res.data.workerID;
          localStorage.firstName = 'Friend!';
          localStorage.accountProgress = res.data.accountProgress;
          this.$router.push({ name: 'Demographic' });
          this.message = 'Success';
          this.showMessage = true;
          this.isDisabled = false;
        } else if (res.data.status === 'existed') {
          this.notQualify = true;
        } else if (res.data.status === 'bot') {
          console.log(res.data.status);
          this.message = 'Sign Up Recaptcha Failed: if you have any questions, please contact lrntnkdo@pitt.edu';
          this.showMessage = true;
          this.isDisabled = false;
        }
      }).catch((err) => {
        this.message = this.getErrorMessage(err);
        this.message = 'Sign Up Error: if you have any questions, please contact lrntnkdo@pitt.edu';
        this.showMessage = true;
        this.isDisabled = false;
        // helper to get a displayable message to the user
      }).then(() => {
        this.btnText = 'Sign Up';
      });
    },
    getErrorMessage(err) {
      let responseBody;
      responseBody = err.response;
      if (!responseBody) {
        responseBody = err;
      } else {
        responseBody = err.response.data || responseBody;
      }
      return responseBody.message || JSON.stringify(responseBody);
    },
    onCaptchaExpired() {
      this.$refs.recaptcha.reset();
    },
  },
  mounted() {
    const recaptchaScript = document.createElement('script');
    recaptchaScript.setAttribute('src', 'https://www.google.com/recaptcha/api.js?onload=vueRecaptchaApiLoaded&render=explicit');
    document.head.appendChild(recaptchaScript);
  },
};
</script>
